import React from "react";
import MusicDistributionHero from "./MusicDistributionHero";
import DistributionTools from "./DistributionTools";
import GetDiscovered from "./GetDiscovered";
import LandingText from "./LandingText";
import StoreStrip from "../SellMusic/StoreStrip";
import "./MusicDistribution.css";

const MusicDistribution = () => {
  return (
    <div
      className="music_services"
      style={{ background: "#000", minHeight: "100vh" }}
    >
      <MusicDistributionHero
        headingbefore="Top"
        mark="Music Distribution"
        headingafter="Services & Solutions"
        detail="Music distribution services transform melodies into worldwide sensations."
      />
      <DistributionTools />
      <GetDiscovered />
      <StoreStrip />
      <LandingText />
    </div>
  );
};

export default MusicDistribution;
